<template>
	<div class="text-center">
		<div
			:class="[
				'bg-gray text-gray-dark rounded-4xl text-xs mx-auto py-2 px-4 max-w-150 inline-block wrap-anywhere'
			]"
			v-bind="$attrs"
		>
			<slot></slot>
		</div>
	</div>
</template>

<script setup lang="ts">
defineOptions({
	inheritAttrs: false
})
</script>

<style scoped></style>
